import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Hero, PageWrapper, HelmetWrap } from './../../components';
import DesktopGrid from './desktop-grid/DesktopGrid';
import MobileGrid from './mobile-grid/MobileGrid';
import { breakpoints } from './../../styles/theme.json';
import scrollToComponent from 'react-scroll-to-component';
import Waypoint from 'react-waypoint';


class Home extends Component {

  constructor(props) {
    super(props);
    this._scrollHandler = this._scrollHandler.bind(this);
    this._handleWaypointEnter = this._handleWaypointEnter.bind(this);
    this.isDesktop = this.props.window_width >= breakpoints.desktop ? true : false;
  }

  _handleWaypointEnter = (e) => {
    if (this.props.scrollDirection == 'scrolling-up' && (this.isDesktop)) {
      scrollToComponent(this.PageTopScrollpoint, { offset: 0, align: 'top', duration: 500, ease: 'linear' });
    }
  }

  _scrollHandler = (e) => {
    if (document.scrollingElement.scrollTop > 150 && (this.isDesktop)) {
      scrollToComponent(this.DesktopGridScrollpoint, { offset: 0, align: 'top', duration: 500, ease: 'linear' });
      window.removeEventListener('scroll', this._scrollHandler);
    }
  }

  componentDidMount() {
    if (this.isDesktop) {
      window.addEventListener('scroll', this._scrollHandler);
    }
  }

  componentWillUnmount() {
    if (this.isDesktop) {
      window.removeEventListener('scroll', this._scrollHandler);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.scrollDirection == 'top' && this.isDesktop) {
      window.addEventListener('scroll', this._scrollHandler);
    }
  }

  render() {
    return (
      <PageWrapper pageId={'home'}>
        <div ref={(div) => { this.PageTopScrollpoint = div; }} />
        <HelmetWrap pageMeta={this.props.data.homeData.data.page_meta}/>
        <Hero sliderContent={this.props.data.homeData.data.hero_slider}/>
        <div ref={(div) => { this.DesktopGridScrollpoint = div; }} />
        <Waypoint onEnter={this._handleWaypointEnter} />
        {(this.props.window_width >= breakpoints.desktop)
          ? <DesktopGrid data={this.props.data.homeData.data.latest}/>
          : <MobileGrid data={this.props.data.homeData.data.latest}/>
        }
      </PageWrapper>
    );
  };
};

export default connect(
  state => ({
    data: state.staticContent,
    window_width: state.window_dimensions.window_width,
    window_height: state.window_dimensions.window_height,
    scrollDirection: state.scroll_direction
  })
)(Home);



// WEBPACK FOOTER //
// ./src/pages/home/Home.js